import { render, staticRenderFns } from "./DeleteBlockedFinancialModal.vue?vue&type=template&id=3243518a&scoped=true"
import script from "./DeleteBlockedFinancialModal.vue?vue&type=script&lang=js"
export * from "./DeleteBlockedFinancialModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteBlockedFinancialModal.vue?vue&type=style&index=0&id=3243518a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3243518a",
  null
  
)

export default component.exports